<template>
  <div class="myCheck">
    <label class="checkbox_label" :for="name">
      <span v-if="isCheck" class="icon pre lx-pointer"></span>
      <span v-else class="icon nor lx-pointer"></span>
    </label>
    <slot name="checkbox"></slot>
  </div>
</template>
<script>
export default {
  name: "MyCheck",
  props: {
    isCheck: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },
};
</script>
<style lang="less" scoped>
.myCheck {
  position: relative;
  width: 20px;
  height: 20px;
}
.checkbox_label {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  .icon {
    display: inline-block;
    width: 100%;
    height: 100%;
    background-size: cover;
    &.nor {
      background-image: url("./icon-check-nor.png");
    }
    &.pre {
      background-image: url("./icon-check-pre.png");
    }
  }
}
</style>
